module.exports = __webpack_public_path__ + "img/programme-1.6eacad63.png";